import { NodeBaseModel } from '../models';
import { NodeBaseDto } from '../types';
import { InstanceUtils } from '.';

export default class NodeUtils {
    static getSections(node: NodeBaseModel | undefined, layerId?: string) {
        if (InstanceUtils.isSectionsNode(node)) {
            return node.sections;
        }

        if (InstanceUtils.isLayersWithSectionsNode(node)) {
            return node.layers.find(layer => layer.id === layerId)?.sections ?? [];
        }

        return [];
    }

    static copyNodeDtos(nodes: NodeBaseModel[]): NodeBaseDto[] {
        return NodeUtils.deepCloneNodeDtos(nodes.map(node => node.dto));
    }

    static deepCloneNodeDtos(nodes: NodeBaseDto[]): NodeBaseDto[] {
        return JSON.parse(JSON.stringify(nodes));
    }
}
